import React, { forwardRef } from 'react';
import { StyledLayout } from './index.styles.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Layout = forwardRef(({ className, margin, padding, children, align, direction, justify, wrap, rowGap, columnGap, as, ...rest }, ref) => {
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    return (React.createElement(StyledLayout, { ...a11yProps, ...dataProps, ref: ref, flexAlign: align, flexDirection: direction, flexJustify: justify, flexWrap: wrap, className: className, margin: margin, padding: padding, rowGap: rowGap, columnGap: columnGap, as: as }, children));
});
Layout.displayName = 'Layout';
//# sourceMappingURL=index.js.map